import { Device } from '@shared/models';
import { DeviceStatusTypes } from '@shared/enums';

export function deviceConnectionStatusLabel(
  device: Pick<Device, 'ConnectionId' | 'SerialNumber' | 'StatusType'>
): string {
  if (device.ConnectionId) return 'Connected';
  if (device.SerialNumber && (device.StatusType & DeviceStatusTypes.Registered) === DeviceStatusTypes.Registered) {
    return 'Registered';
  }
  return 'Inactive';
}

export function deviceConnectionStatusSeverity(_device: Pick<Device, 'ConnectionId'>): 'info' {
  return 'info';
}
